import React, { PureComponent } from 'react';

import { injectIntl, InjectedIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { FieldTextStateless } from '@atlaskit/field-text';

import Path from 'src/components/path';

import messages from './editable-file-path.i18n';

export type Props = {
  intl: InjectedIntl;
  onChange: (path: string) => void;
  path: string;
  repositorySlug: string;
};

class EditableFilePath extends PureComponent<Props> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    onChange: () => {},
  };

  getFilename = () => this.props.path.split('/').slice(-1)[0];
  getParentPathSegments = () => this.props.path.split('/').slice(0, -1);

  handleInputChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    // @ts-ignore
    const newFilename = e.target.value;

    // Don't allow empty directory names in the path
    if (newFilename.indexOf('/') === 0 || newFilename.indexOf('//') !== -1) {
      return;
    }

    const parentPathSegments = this.props.path.split('/').slice(0, -1);
    const newPath = [...parentPathSegments, newFilename].join('/');

    this.props.onChange(newPath);
  };

  handleKeyDown = (e: React.KeyboardEvent) => {
    // This is the filename before the keypress takes effect
    const filename = this.getFilename();

    /**
     * If the input is empty and backspace/delete is hit:
     *
     * 1) Remove the currently focused input field from the DOM
     * 2) Replace the previous path segment with an input field containing that segment's value
     * 3) Move focus into the new input field
     *
     * If the current header is: foo / bar / <input value="" />
     * it becomes: foo / <input value="bar" />
     */
    if (e.key === 'Backspace' && filename === '') {
      this.props.onChange(this.getParentPathSegments().join('/'));
      e.preventDefault();
    }
  };

  render() {
    const { intl, repositorySlug } = this.props;

    const currentSegment = (
      <FieldTextStateless
        autoFocus
        compact
        isLabelHidden
        key="segment-current"
        onChange={this.handleInputChange}
        onKeyDown={this.handleKeyDown}
        placeholder={intl.formatMessage(messages.filenamePlaceholder)}
        value={this.getFilename()}
      />
    );

    return (
      <Path>
        {[repositorySlug, ...this.getParentPathSegments(), currentSegment]}
      </Path>
    );
  }
}

export default injectIntl(EditableFilePath);
